import { type FC } from 'react';
import cx from 'classnames';

// @ts-expect-error - PlusIcon doesn't have TypeScript definitions
import PlusIcon from 'src/assets/icons/Plus';
// @ts-expect-error - CustomButton doesn't have TypeScript definitions
import { CUSTOM_BUTTON_COLOR, CustomButton } from 'src/components/CustomButton';
import { type Callback } from 'src/lib/types';

import { WIDGET_ACTION, type WidgetAction } from '../../lib';

import styles from './styles.module.scss';

interface ActionsProps {
  className: string;
  onAction: Callback<WidgetAction>;
  disabled: boolean;
}

export const Actions: FC<ActionsProps> = ({ className, onAction, disabled }) => {
  return (
    <div className={cx(styles.root, className)}>
      <CustomButton
        className={styles.buttonAction}
        onClick={() => onAction(WIDGET_ACTION.createBlankProject)}
        disabled={disabled}
        startIcon={<PlusIcon />}
        color={CUSTOM_BUTTON_COLOR.silver}
        data-testid="buttonNewBlankProject"
      >
        New blank project
      </CustomButton>

      <CustomButton
        className={styles.buttonAction}
        onClick={() => onAction(WIDGET_ACTION.improveContent)}
        disabled={disabled}
        color={CUSTOM_BUTTON_COLOR.silver}
        data-testid="buttonImproveContent"
      >
        Improve existing content
      </CustomButton>

      <CustomButton
        className={styles.buttonAction}
        onClick={() => onAction(WIDGET_ACTION.openTemplateGallery)}
        disabled={disabled}
        color={CUSTOM_BUTTON_COLOR.silver}
        data-testid="buttonTemplateGallery"
      >
        Template gallery
      </CustomButton>

      <CustomButton
        className={styles.buttonAction}
        onClick={() => onAction(WIDGET_ACTION.openSavedTemplates)}
        disabled={disabled}
        color={CUSTOM_BUTTON_COLOR.silver}
        data-testid="buttonSavedTemplates"
      >
        Saved templates
      </CustomButton>
    </div>
  );
};
